import React from "react";
import CommonRow from "../common-row";

const FiveOpinionStories = props => {
  return <CommonRow {...props} />;
};

export default FiveOpinionStories;
